<template>
  <div
    data-cy="log-comments-section"
    class="flex flex-col flex-col-reverse space-y-4 border-t"
  >
    <div
      :class="[
        {
          'space-y-4 p-4 shadow-main': isSms,
        },
        { 'p-4': !isInboxPage },
      ]"
    >
      <div v-if="!comments.length" class="flex items-center justify-center">
        <p class="py-5">
          {{ $t("ACTIVITY.COMMENTS.EMPTY") }}
        </p>
      </div>
      <log-comment-form />
    </div>

    <div
      v-if="comments.length"
      class="flex flex-col flex-col-reverse gap-y-8 p-4"
    >
      <log-comment
        v-for="comment in comments"
        :key="comment.id"
        :data="comment"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCommunicationLogs } from "@/hooks/communicationLogs";

import LogComment from "@/components/communicationLogs/comments/LogComment.vue";
import LogCommentForm from "@/components/communicationLogs/comments/LogCommentForm.vue";

import type { CommunicationLogComment } from "@/models/communicationLogs";

const { comments = [] } = defineProps<{
  comments: CommunicationLogComment[];
  isSms?: boolean;
}>();

const { isInboxPage } = useCommunicationLogs();
</script>
